import { render, staticRenderFns } from "./CompanyForms.vue?vue&type=template&id=3428fb01&"
import script from "./CompanyForms.vue?vue&type=script&lang=js&"
export * from "./CompanyForms.vue?vue&type=script&lang=js&"
import style0 from "./CompanyForms.vue?vue&type=style&index=0&id=3428fb01&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports